export default __webpack_public_path__ + "static/media/talakad.6f93b05a.jpg";